// extracted by mini-css-extract-plugin
module.exports = {"jcGrey900":"#161f32","jcWarning100":"#ffe9bf","newBadge":"NewBadge__newBadge"};